/* eslint-disable prettier/prettier */
import { createSortOption } from "@nosto/preact"
export const sizes = [40, 48, 72]

export const sortOptions = [
    createSortOption("score", "Featured", { field: "_score", order: "desc" }),
    createSortOption("stats.revenue", "Best selling", { field: "stats.revenue", order: "desc" }),
    createSortOption("name", "Alphabetically, A-Z", { field: "name", order: "asc" }),
    createSortOption("-name", "Alphabetically, Z-A", { field: "name", order: "desc" }),
    createSortOption("price", "Price,  low to high", { field: "price", order: "asc" }),
    createSortOption("-price", "Price, high to low", { field: "price", order: "desc" }),
    createSortOption("date published", "Date, old to new", { field: "datePublished", order: "asc" }),
    createSortOption("-date published", "Date, new to old", { field: "datePublished", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5
}

export const productCarouselOptions = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    loop: false,
    loopAddBlankSlides: true,
    navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
    },
    preventClicks: true,
    preventClicksPropagation: true,
    watchOverflow: true,
    watchSlidesProgress: true,
    pagination: false,

    /*  Oct. 1st (added) */
    focusableElements: "input, select, option, textarea, button, video, label",
    shortSwipes: true,
    longSwipes: true,
    // touchRatio: 1,
    longSwipesMs: 300,
    longSwipesRatio: 0.5,
    effect: "slide",
    followFinger: true,
    edgeSwipeDetection: false,
    loopedSlidesLimit: true,
    resistance: true,
    resistanceRatio: 0.85,
    resizeObserver: true,
    speed: 300,
    threshold: 0,
    touchAngle: 45,
    touchEventsTarget: "wrapper",
    touchMoveStopPropagation: false,
    touchRatio: 1,
    touchReleaseOnEdges: false,
    touchStartForcePreventDefault: false,
    touchStartPreventDefault: true,
    // effect: 'fade',
    // fadeEffect: {
    //     crossFade: false,
    // },
    // shortSwipes: false,
    // edgeSwipeDetection: true,

    /* options from native swiper */
    // allowSlideNext: true,
    // allowSlidePrev: true,
    // allowTouchMove: true,
    // autoHeight: false,
    // breakpoints: undefined,
    // breakpointsBase: "window",
    // centerInsufficientSlides: false,
    // centeredSlides: false,
    // centeredSlidesBounds: false,
    // containerModifierClass: "swiper-",
    // createElements: false,
    // cssMode: false,
    // direction: "horizontal",
    // edgeSwipeDetection: false,
    // edgeSwipeThreshold: 20,
    // effect: "slide",
    // enabled: true,
    // focusableElements: "input, select, option, textarea, button, video, label",
    // followFinger: true,
    // grabCursor: false,
    // height: null,
    // init: false,
    // initialSlide: 0,
    // longSwipes: true,
    // longSwipesMs: 300,
    // longSwipesRatio: 0.5,
    // loop: true,
    // loopAdditionalSlides: 0,
    // loopFillGroupWithBlank: false,
    // loopPreventsSlide: true,
    // loopedSlides: null,
    // loopedSlidesLimit: true,
    // navigation: false,
    // nested: false,
    // noSwiping: true,
    // noSwipingClass: "swiper-no-swiping",
    // noSwipingSelector: null,
    // normalizeSlideIndex: true,
    // pagination: {
    //     bulletActiveClass: "swiper-pagination-bullet-active bg-gray-800",
    //     bulletClass: "swiper-pagination-bullet h-full flex-grow block",
    //     el: ".swiper-pagination",
    //     type: "bullets",
    // },
    // passiveListeners: true,
    // preloadImages: true,
    // preventClicks: true,
    // preventClicksPropagation: true,
    // preventInteractionOnTransition: false,
    // resistance: true,
    // resistanceRatio: 0.85,
    // resizeObserver: true,
    // rewind: false,
    // roundLengths: false,
    // runCallbacksOnInit: true,
    // setWrapperSize: false,
    // shortSwipes: true,
    // simulateTouch: true,
    // slideActiveClass: "swiper-slide-active",
    // slideBlankClass: "swiper-slide-invisible-blank",
    // slideClass: "swiper-slide",
    // slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    // slideDuplicateClass: "swiper-slide-duplicate",
    // slideDuplicateNextClass: "swiper-slide-duplicate-next",
    // slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    // slideNextClass: "swiper-slide-next",
    // slidePrevClass: "swiper-slide-prev",
    // slideToClickedSlide: false,
    // slideVisibleClass: "swiper-slide-visible",
    // slidesOffsetAfter: 0,
    // slidesOffsetBefore: 0,
    // slidesPerGroup: 1,
    // slidesPerGroupAuto: false,
    // slidesPerGroupSkip: 0,
    // slidesPerView: 1,
    // spaceBetween: 0,
    // speed: 300,
    // swipeHandler: null,
    // threshold: 0,
    // touchAngle: 45,
    // touchEventsTarget: "wrapper",
    // touchMoveStopPropagation: false,
    // touchRatio: 1,
    // touchReleaseOnEdges: false,
    // touchStartForcePreventDefault: false,
    // touchStartPreventDefault: true,
    // uniqueNavElements: true,
    // updateOnImagesReady: true,
    // updateOnWindowResize: true,
    // url: null,
    // userAgent: null,
    // virtualTranslate: false,
    // watchOverflow: true,
    // watchSlidesProgress: false,
    // width: null,
    // wrapperClass: "swiper-wrapper",
}

export const productSizeCarouselOptions = {
    slidesPerView: 1, 
    spaceBetween: 0,
    watchOverflow: true,
    loop: false,
    navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
    },
    pagination: false,
}

export const popularSearches = [
    {
        name: "Tees",
        url: "/search?q=Tees",
    },
    {
        name: "Hoodies",
        url: "/search?q=Hoodies",
    },
    {
        name: "Cargo Pants",
        url: "/search?q=Cargo+Pants",
    },
    {
        name: "Coats",
        url: "/search?q=Coats",
    },
    {
        name: "Fleece Pants",
        url: "/search?q=Fleece+Pants",
    },
    {
        name: "Hat",
        url: "/search?q=Hat",
    }
]